import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Cadastro from '@/components/Cadastro'
import Inicio from '@/components/Inicio'
import Configuracoes from '@/components/Configuracoes'
import Pedidos from '@/components/Pedidos'
import Conta from '@/components/Conta'
import AlterarSenha from '@/components/AlterarSenha'
import Usuarios from '@/components/Usuarios'
import Pacientes from '@/components/Pacientes'
import Profissionais from '@/components/Profissionais'
import Saques from '@/components/Saques'
import Cupons from '@/components/Cupons'
import GerenciarCupons from '@/components/GerenciarCupons'
import Informacoes from '@/components/Informacoes'
import Carteira from '@/components/Carteira'
import Agendas from '@/components/Agendas'
import Servicos from '@/components/Servicos'
import Empresas from '@/components/Empresas'
import GerenciarAgendas from '@/components/GerenciarAgendas'
import GerenciarServicos from '@/components/GerenciarServicos'
import DetalhesPedidos from '@/components/DetalhesPedidos'
import ConfigurarAgendas from '@/components/ConfigurarAgendas'
import Profissoes from '@/components/Profissoes'
import GerenciarProfissoes from '@/components/GerenciarProfissoes'
import Especialidades from '@/components/Especialidades'
import GerenciarEspecialidades from '@/components/GerenciarEspecialidades'
import RecuperarSenha from '@/components/RecuperarSenha'
import VisualizarPrescricao from '@/components/VisualizarPrescricao'
import CertificadoResultado from '@/components/CertificadoResultado'
import Contato from '@/components/Contato'
import Avaliacoes from '@/components/Avaliacoes'
import GerenciarUsuarios from '@/components/GerenciarUsuarios'
import GerenciarEmpresas from '@/components/GerenciarEmpresas'
import GerenciarPrestadores from '@/components/GerenciarPrestadores'
import GerenciarPacientes from '@/components/GerenciarPacientes'
import ProntuarioPacientes from '@/components/ProntuarioPacientes'
import GerenciarPedidos from '@/components/GerenciarPedidos'
import PrestadoresEmpresas from '@/components/PrestadoresEmpresas'
import VisualizarHorarios from '@/components/VisualizarHorarios'
import { isMobile } from 'mobile-device-detect';
var loggedRoute 		= "Inicio";
var notLoggedRoute 	= "Login";

Vue.use(Router)

const checkLogin 	= (to, from, next) => {
    var self    	= this;

    if (!window.localStorage.getItem("_usuario")) {
        if (to.meta.auth == false || typeof to.meta.auth == "undefined") {
	   		next();
	   		return;             	
        }
        if (to.meta.auth == true) {
        }        
    } else {
        var usuario = null;
        try {
            usuario = JSON.parse(window.localStorage.getItem("_usuario"));
            window.__usuario = usuario;
            if (usuario.cod) {
		        if (to.meta.auth == false) {
				 	_this.push({ 
					   	name: loggedRoute,
					   	params: {
					   		"reload": 1 	
					   	}
				 	}).catch(()=>{});			
				 	if (_this.currentRoute.params.reload == 1) {
				 		window.location.reload();   		
			   		}
			   		return;             	
		        }

		        if (to.meta.auth && to.meta.level) {
		        	if (to.meta.level.indexOf(usuario.tipo) == -1) {
					 	_this.push({ 
						   	name: loggedRoute
					 	}).catch(()=>{});					        		
		        	}
		        }
	            
       
		   		next();
		   		return;            
            } else {
            }

        } catch(err) {
            // return false;
        }
    }
    
 	_this.push({ 
	   	name: notLoggedRoute
 	}).catch(()=>{});
};

var _this = new Router({
  	routes: [
	    {
	      	path: '/',
	      	name: 'Inicio',
	      	meta: {
	      		title: 		"Osis",
	      		auth: 		true,
	      	},
	      	component: Inicio,
	      	beforeEnter: checkLogin,
	    }, 		     	     	
	    {
	      	path: '/login/',
	      	name: 'Login',
	      	meta: {
	      		title: 		"Login",
	      		auth: 		false,
	      	},
	      	component: Login,
	      	beforeEnter: checkLogin,
	    }, 
	    {
	      	path: '/cadastro/',
	      	name: 'Cadastro',
	      	meta: {
	      		title: 		"Cadastro",
	      		auth: 		false,
	      	},
	      	component: Cadastro,
	      	beforeEnter: checkLogin,
	    },     	    	    	      
	    {
	      	path: '/agendamentos/',
	      	name: 'Pedidos',
	      	meta: {
	      		title: 		"Agendamentos",
		      	auth: 		true,
		      	// backButton: false,
		      	level: 		["admin", "contratante", "prestador"],
	      	},
	      	component: Pedidos,
	      	beforeEnter: checkLogin,
	    }, 	 
	    {
	      	path: '/avaliacoes/',
	      	name: 'Avaliacoes',
	      	meta: {
	      		title: 		"Avaliacoes",
		      	auth: 		true,
		      	backButton: false,
		      	level: 		["admin"],
	      	},
	      	component: Avaliacoes,
	      	beforeEnter: checkLogin,
	    }, 	 
	    {
	      	path: '/empresas/',
	      	name: 'Empresas',
	      	meta: {
	      		title: 		"Empresas",
		      	auth: 		true,
		      	backButton: false,
		      	level: 		["admin"],
	      	},
	      	component: Empresas,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/empresas/profissionais',
	      	name: 'PrestadoresEmpresas',
	      	meta: {
	      		title: 		"Profissionais da empresa",
		      	auth: 		true,
		      	backButton: false,
		      	level: 		["admin", "empresa"]
	      	},
	      	component: PrestadoresEmpresas,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/empresas/cadastro',
	      	name: 'CadastrarEmpresas',
	      	meta: {
	      		title: 		"Cadastrar empresa",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarEmpresas,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/empresas/editar',
	      	name: 'EditarEmpresas',
	      	meta: {
	      		title: 		"Editar empresa",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarEmpresas,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/agendamentos/cadastro',
	      	name: 'CadastrarPedidos',
	      	meta: {
	      		title: 		"Cadastrar agendamento",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador"]
	      	},
	      	component: GerenciarPedidos,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/agendamentos/editar',
	      	name: 'EditarPedidos',
	      	meta: {
	      		title: 		"Editar agendamento",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador"]
	      	},
	      	component: GerenciarPedidos,
	      	beforeEnter: checkLogin,
	    },		    	     	 	    
	    {
	      	path: '/horarios',
	      	name: 'VisualizarHorarios',
	      	meta: {
	      		title: 		"Horários",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador", "admin"],
	      	},
	      	component: VisualizarHorarios,
	      	beforeEnter: checkLogin,
	    },		 	    	          
	    // {
	    //   	path: '/categorias/',
	    //   	name: 'Categorias',
	    //   	meta: {
	    //   		title: 		"Categorias",
		   //    	auth: 		true,
		   //    	// backButton: false,
		   //    	level: 		["admin", "prestador"],
	    //   	},
	    //   	component: Categorias,
	    //   	beforeEnter: checkLogin,
	    // },	    
	    {
	      	path: '/minha-conta/',
	      	name: 'Conta',
	      	meta: {
	      		title: 		"Minha conta",
		      	auth: 		true,
		      	level: 		["admin", "contratante", "prestador", "empresa"],
	      	},
	      	component: Conta,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/informacoes/',
	      	name: 'Informacoes',
	      	meta: {
	      		title: 		"Informações",
		      	auth: 		true,
		      	level: 		["admin", "prestador"],
		      	// backButton: false,
	      	},
	      	component: Informacoes,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/informacoes/',
	      	name: 'Informacoes',
	      	meta: {
	      		title: 		"Informações",
		      	auth: 		true,
		      	level: 		["admin", "prestador"],
		      	// backButton: false,
	      	},
	      	component: Informacoes,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/saques/',
	      	name: 'Saques',
	      	meta: {
	      		title: 		"Saques",
		      	auth: 		true,
		      	level: 		["admin", "prestador"],
		      	// backButton: false,
	      	},
	      	component: Saques,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/cupons/',
	      	name: 'Cupons',
	      	meta: {
	      		title: 		"Cupons",
		      	auth: 		true,
		      	level: 		["admin", "prestador"],
		      	// backButton: false,
	      	},
	      	component: Cupons,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/cupons/cadastro',
	      	name: 'CadastrarCupons',
	      	meta: {
	      		title: 		"Cadastrar cupom",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador"],
	      	},
	      	component: GerenciarCupons,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/cupons/editar',
	      	name: 'EditarCupons',
	      	meta: {
	      		title: 		"Editar cupom",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador"],
	      	},
	      	component: GerenciarCupons,
	      	beforeEnter: checkLogin,
	    },			        	    
	    {
	      	path: '/configuracoes/',
	      	name: 'Configuracoes',
	      	meta: {
	      		title: 		"Configurações",
		      	auth: 		true,
		      	level: 		["admin", "prestador"],
		      	// backButton: false,
	      	},
	      	component: Configuracoes,
	      	beforeEnter: checkLogin,
	    },	 	       
	    {
	      	path: '/alterar-senha/',
	      	name: 'AlterarSenha',
	      	meta: {
	      		title: 		"Alterar senha",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "contratante", "prestador", "empresa"],
	      	},
	      	component: AlterarSenha,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/carteira/',
	      	name: 'Carteira',
	      	meta: {
	      		title: 		"Carteira",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador"],
	      	},
	      	component: Carteira,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/contato/',
	      	name: 'Contato',
	      	meta: {
	      		title: 		"Contato",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador", "contratante", "empresa"],
	      	},
	      	component: Contato,
	      	beforeEnter: checkLogin,
	    },	 	       
	    {
	      	path: '/usuarios/',
	      	name: 'Usuarios',
	      	meta: {
	      		title: 		"Usuários",
		      	auth: 		true,
		      	backButton: false,
		      	level: 		["admin"],
		      	options: {
		      		"cadastrarBotaoTexto": 		"Cadastrar usuário",
		      		"cadastrarBotaoNome": 		"CadastrarUsuarios",
		      		"editarBotaoNome": 			"EditarUsuariosGeral",
		      		"tipo": 					"admin" 
		      	}
	      	
	      	},
	      	component: Usuarios,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/pacientes/',
	      	name: 'Pacientes',
	      	meta: {
	      		title: 		"Pacientes",
		      	auth: 		true,
		      	backButton: false,
		      	level: 		["admin", "prestador"],
		      	options: {
		      		"tipo": 					"contratante" 
		      	}
	      	
	      	},
	      	component: Pacientes,
	      	beforeEnter: checkLogin,
	    },	   
	    {
	      	path: '/pacientes/cadastro',
	      	name: 'CadastrarPacientes',
	      	meta: {
	      		title: 		"Cadastrar paciente",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador"]
	      	},
	      	component: GerenciarPacientes,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/pacientes/editar',
	      	name: 'EditarPacientes',
	      	meta: {
	      		title: 		"Editar paciente",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador", "admin"]
	      	},
	      	component: GerenciarPacientes,
	      	beforeEnter: checkLogin,
	    },		
	    {
	      	path: '/pacientes/prontuario',
	      	name: 'ProntuarioPacientes',
	      	meta: {
	      		title: 		"Prontuário paciente",
		      	auth: 		true,
		      	backButton: false,
		      	level: 		["prestador"]
	      	},
	      	component: ProntuarioPacientes,
	      	beforeEnter: checkLogin,
	    },			        
	    {
	      	path: '/profissionais/',
	      	name: 'Profissionais',
	      	meta: {
	      		title: 		"Profissionais",
		      	auth: 		true,
		      	backButton: false,
		      	level: 		["admin"],
		      	options: {
		      		"tipo": 					"prestador" 
		      	}
	      	
	      	},
	      	component: Profissionais,
	      	beforeEnter: checkLogin,
	    },		    	    	    		    	 	 	    		 	       
	    {
	      	path: '/agendas/',
	      	name: 'Agendas',
	      	meta: {
	      		title: 		"Agendas",
		      	backButton: false,
		      	level: 		["prestador"],
	      	},
	      	component: Agendas,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/servicos/',
	      	name: 'Servicos',
	      	meta: {
	      		title: 		"Servicos",
		      	level: 		["prestador"],
		      	backButton: false,
	      	},
	      	component: Servicos,
	      	beforeEnter: checkLogin,
	    },		            
	    {
	      	path: '/agendas/cadastro',
	      	name: 'CadastrarAgendas',
	      	meta: {
	      		title: 		"Cadastrar agenda",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador"]
	      	},
	      	component: GerenciarAgendas,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/agendas/configuracoes',
	      	name: 'ConfigurarAgendas',
	      	meta: {
	      		title: 		"Gerenciar agenda",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador"]
	      	},
	      	component: ConfigurarAgendas,
	      	beforeEnter: checkLogin,
	    },		    
	    {
	      	path: '/agendas/editar',
	      	name: 'EditarAgendas',
	      	meta: {
	      		title: 		"Editar agenda",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador"]
	      	},
	      	component: GerenciarAgendas,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/agendamento/detalhes',
	      	name: 'DetalhesPedidos',
	      	meta: {
	      		title: 		"Detalhes do agendamento",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador", "contratante", "admin"]
	      	},
	      	component: DetalhesPedidos,
	      	beforeEnter: checkLogin,
	    },		 
	    {
	      	path: '/servicos/cadastro',
	      	name: 'CadastrarServicos',
	      	meta: {
	      		title: 		"Cadastrar serviço",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador"]
	      	},
	      	component: GerenciarServicos,
	      	beforeEnter: checkLogin,
	    },		    
	    {
	      	path: '/servicos/editar',
	      	name: 'EditarServicos',
	      	meta: {
	      		title: 		"Editar serviço",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["prestador"]
	      	},
	      	component: GerenciarServicos,
	      	beforeEnter: checkLogin,
	    },		    
	    {
	      	path: '/usuarios/cadastro',
	      	name: 'CadastrarUsuarios',
	      	meta: {
	      		title: 		"Cadastrar usuário",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarUsuarios,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/usuarios/editar',
	      	name: 'EditarUsuariosGeral',
	      	meta: {
	      		title: 		"Editar usuário",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarUsuarios,
	      	beforeEnter: checkLogin,
	    },	   
	    {
	      	path: '/profissionais/cadastro',
	      	name: 'CadastrarPrestadores',
	      	meta: {
	      		title: 		"Cadastrar profissional",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "empresa"]
	      	},
	      	component: GerenciarPrestadores,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/profissionais/editar',
	      	name: 'EditarPrestadores',
	      	meta: {
	      		title: 		"Editar profissional",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "empresa"]
	      	},
	      	component: GerenciarPrestadores,
	      	beforeEnter: checkLogin,
	    },	   	     		
	    {
	      	path: '/especialidades/',
	      	name: 'Especialidades',
	      	meta: {
	      		title: 		"Especialidades",
		      	auth: 		true,
		      	// backButton: false,
		      	level: 		["admin", "prestador"],
	      	},
	      	component: Especialidades,
	      	beforeEnter: checkLogin,
	    },	 	        	        
	    {
	      	path: '/especialidades/cadastro',
	      	name: 'CadastrarEspecialidades',
	      	meta: {
	      		title: 		"Cadastrar especialidade",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarEspecialidades,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/especialidades/editar',
	      	name: 'EditarEspecialidades',
	      	meta: {
	      		title: 		"Editar especialidade",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarEspecialidades,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/profissoes/',
	      	name: 'Profissoes',
	      	meta: {
	      		title: 		"Profissoes",
		      	auth: 		true,
		      	// backButton: false,
		      	level: 		["admin", "prestador"],
	      	},
	      	component: Profissoes,
	      	beforeEnter: checkLogin,
	    },	 	    
	    {
	      	path: '/profissoes/cadastro',
	      	name: 'CadastrarProfissoes',
	      	meta: {
	      		title: 		"Cadastrar profissão",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarProfissoes,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/profissoes/editar',
	      	name: 'EditarProfissoes',
	      	meta: {
	      		title: 		"Editar profissão",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarProfissoes,
	      	beforeEnter: checkLogin,
	    },		           
	    {
	      	path: '/recuperar-senha/',
	      	name: 'RecuperarSenha',
	      	meta: {
	      		title: 		"Recuperar senha",
	      		// auth: 		false,
	      	},
	      	component: RecuperarSenha,
	      	beforeEnter: checkLogin,
	    },
	    {
			path: '/prescricao/',
			name: 'VisualizarPrescricao',
			meta: {
				title: 		"Visualizar prescrição digital",
				// auth: 		false,
			},
			component: VisualizarPrescricao,
			beforeEnter: checkLogin,
	  	},
		  {
			path: '/certificado-resultado/',
			name: 'CertificadoResultado',
			meta: {
				title: 		"Conectar Certificado Digital",
				// auth: 		false,
			},
			component: CertificadoResultado,
			beforeEnter: checkLogin,
	  	},		
	    { path: '*', redirect: '/' }
  	]
})


const scrollPositions = Object.create(null)

_this.beforeEach((to, from, next) => {

  	let element = $(".page-content")[0];
  	if (element) {
	    scrollPositions[from.name] = element.scrollTop
  	}

  	next()
})

window.addEventListener('popstate', () => {
	setTimeout(function() {
	  	let currentRouteName = _this.history.current.name
	  	let element = $(".page-content")[0];
	  	if (element && scrollPositions[currentRouteName]) {
	    	element.scrollTop = scrollPositions[currentRouteName];
	    	scrollPositions[currentRouteName] = null;
	  	}
	}, 100);
})

export default _this;


// WEBPACK FOOTER //
// ./src/router/index.js